/** Adapt Worker API rows to SPA view models (locale already flattened). */

export type CatalogItem = {
  id: string;
  slug: string;
  name: string;
  title?: string;
  description: string;
  city?: string;
  region?: string;
  category?: string;
  featured?: boolean;
  isDemo: boolean;
  latitude?: number | null;
  longitude?: number | null;
  image?: string;
  score?: number;
  distanceKm?: number;
  type?: string;
  [key: string]: unknown;
};

export function imageOf(item: Record<string, unknown>): string | undefined {
  if (typeof item.image === "string" && item.image) return item.image;
  if (Array.isArray(item.media) && item.media[0]) {
    const first = item.media[0] as { url?: string };
    if (first?.url) return first.url;
  }
  return undefined;
}

export function normalizeCatalogItem(raw: Record<string, unknown>): CatalogItem {
  return {
    ...raw,
    id: String(raw.id ?? ""),
    slug: String(raw.slug ?? ""),
    name: String(raw.name || raw.title || ""),
    title: raw.title != null ? String(raw.title) : undefined,
    description: String(raw.description || raw.body || ""),
    city: raw.city != null ? String(raw.city) : undefined,
    region: raw.region != null ? String(raw.region) : undefined,
    category: raw.category != null ? String(raw.category) : undefined,
    featured: Boolean(raw.featured),
    isDemo: Boolean(raw.isDemo ?? raw.is_demo),
    latitude:
      typeof raw.latitude === "number"
        ? raw.latitude
        : raw.latitude != null
          ? Number(raw.latitude)
          : null,
    longitude:
      typeof raw.longitude === "number"
        ? raw.longitude
        : raw.longitude != null
          ? Number(raw.longitude)
          : null,
    image: imageOf(raw),
    score: raw.score != null ? Number(raw.score) : undefined,
    distanceKm: raw.distanceKm != null ? Number(raw.distanceKm) : undefined,
    type: raw.type != null ? String(raw.type) : undefined,
  };
}

export function normalizeList(items: Record<string, unknown>[] | undefined): CatalogItem[] {
  return (items || []).map(normalizeCatalogItem);
}

export function pathForEntityType(type: string): string {
  switch (type) {
    case "destination":
      return "destinations";
    case "attraction":
      return "attractions";
    case "hotel":
      return "hotels";
    case "restaurant":
      return "restaurants";
    case "experience":
      return "experiences";
    case "event":
      return "events";
    case "travel_guide":
    case "guide":
      return "travel-guide";
    default:
      return "destinations";
  }
}
